import React from 'react'
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label} from 'reactstrap'
import apiBarcode from './../../../services/api/apiBarcode'
import {getLanguageStore} from "../../../services/api/apiPlatformIntergation"
import AutoCompletedText from "./AutoCompletedText"

class ModalMarkFailedDesign extends React.Component {
    state = {
        file: null,
        note: '',
        loading: false,
        error: '',
        language: 'vi'
    }

    componentDidMount() {
        this._fetchLanguageStore()
    }

    _handleChangeInput = (value) => {
        this.setState({
            note: value
        })
    }

    _handleClickSave = async () => {
        const {note, file} = this.state
        const {product} = this.props
        const barcode = `${product.barcodeNumber}_${product.pos}`

        this.setState({
            error: '',
            loading: true
        })

        try {
            let formData = new FormData()

            if (file) {
                formData.append('file', file)
            }

            formData.append('note', note)

            const resUpdated = await apiBarcode.requestUpdateDesign(barcode, formData)
            const {success, message} = resUpdated.data

            if (!success) throw new Error(message)

            this.props.toggle()

            await this.props.reload()
        } catch (e) {
            this.setState({
                error: e.message
            })
        }
        this.setState({
            loading: false
        })
    }

    _handleChangeFile = e => {
        const {files} = e.target

        this.setState({
            file: files[0],
            value: e.target.value
        })
    }

    _handleDeleteFile = () => {
        this.setState({
            file: null,
            value: ''
        })
    }

    _fetchLanguageStore = async () => {
        this.setState({
            error: ''
        })

        try {
            const {product} = this.props
            const response = await getLanguageStore(product.storename)

            const {success, data, message: error} = response

            if (!success) {
                return this.setState({
                    error: error
                })
            }

            this.setState({
                language: (data.hasOwnProperty('preferred_language') ? data.preferred_language : 'vi')
            })
        } catch (e) {
            this.setState({
                error: e.message
            })
        }
    }

    render() {
        const {file, error, loading, language} = this.state
        const {isOpen, toggle, product} = this.props

        return (
            <div>
                <Modal isOpen={isOpen} toggle={toggle} className={this.props.className}>
                    <ModalHeader toggle={toggle}>Yêu cầu cập nhật design - <span
                        className="text-danger">{product.barcodeNumber}_{product.pos}</span></ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label>Loại yêu cầu: </Label>
                            <select disabled className="form-control" name="type" value="design">
                                <option value="design">Design</option>
                            </select>
                        </FormGroup>
                        <AutoCompletedText
                            onChange={this._handleChangeInput}
                            language={language}
                            namespace={product.storename}
                            label="Mô tả:"
                            parentClass='RequestDescription'
                        />
                        <FormGroup>
                            <label className="cursor-pointer text-primary mb-0 labelAtackment"
                                   htmlFor={`request_failed_design_${product.barcodeId}`}>
                                Đính kèm file
                            </label>
                            {file && <div className="fileName d-flex align-items-center justify-content-between">
                                <span><i className="fa fa-paperclip mr-1"/> {file.name}</span>
                                <i onClick={this._handleDeleteFile} className="fa fa-trash cursor-pointer"/>
                            </div>}
                            <input
                                type='file'
                                accept='image/png, image/jpeg, image/jpg, image/gif'
                                multiple={false}
                                onChange={this._handleChangeFile}
                                style={{width: 100}}
                                id={`request_failed_design_${product.barcodeId}`}
                                className='d-none'
                                value={this.state.value}
                            />
                        </FormGroup>
                        {error && <div className="text-danger mt-3">{error}</div>}
                    </ModalBody>
                    <ModalFooter className="d-flex justify-content-between align-content-center">
                        <Button disabled={loading} color="secondary" onClick={toggle}>Hủy</Button>
                        <Button disabled={loading} color="primary" onClick={this._handleClickSave}>
                            Gửi yêu cầu {loading && <i className='icon-spinner2 spinner ml-2'/>}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default ModalMarkFailedDesign
